import cloneDeep from 'lodash/cloneDeep';
/**
 * Flatten an ION fields array. This is useful for passing fields to RHF form instance. Object id's will match the path to the individual field from original ION structure. (eg. { id: 'customer.address.line1' })
 * @param {import('../model').Field[]} fields the returned value from getApplicationFields(ion)
 * @param {string} [separator='::'] the separator to use. NOTE: using '.' will cause JOI to convert fields keys to objects.
 * @returns {array} A flat array of objects. Each Object is an application field.
 * @memberof module:ionHelpers
 */
const flattenApplicationFields = (fields, separator = '::', _id) => {
    const reducer = (prev, current) => {
        const { type, id: currentId, value } = current;
        const newField = cloneDeep(current);
        if (_id) {
            // using :: as the separator here because JOI auto converts dotted key names to objects.
            newField.id = `${_id}${separator}${currentId}`;
        }
        if (type === 'FIELDS' && value) {
            const nestedFields = flattenApplicationFields(value, separator, newField.id);
            const newArr = prev.concat(nestedFields);
            return newArr;
        }
        return [...prev, newField];
    };
    const fieldsToUse = Array.isArray(fields) ? fields : [fields];
    return fieldsToUse.reduce(reducer, []);
};
export default flattenApplicationFields;
